import { LocalizedLink } from "../../i18n/LocalizedLink";
import { useLocale } from "../../i18n/useLocale";
import { useGuideSketches } from "../../i18n/useVisualGuides";
import { useVisualGuides } from "../../i18n/useVisualGuides";
import { GuideStepList } from "./GuideStep";
import {
  SketchSimulator,
  SketchSimulatorKeyboard,
  SketchSimulatorOpen,
  SketchWerkplanSettings,
  SketchWerkplanTabBar,
} from "./GuideSketches";

function SketchWerkplanPrepareContext() {
  const s = useGuideSketches();

  return (
    <div className="guide-sketch guide-sketch--card">
      <SketchWerkplanTabBar activeTab="prepare" />
      <p className="guide-sketch-label">{s.visualLayoutSheet1}</p>
      <div className="guide-sketch-print-board guide-sketch-print-board--small" />
    </div>
  );
}

const VISUALS = [
  <SketchWerkplanPrepareContext key="context" />,
  <SketchWerkplanSettings key="settings" />,
  <SketchSimulator key="teaser" />,
  <SketchSimulatorOpen key="open" />,
  <SketchSimulatorKeyboard key="keyboard" />,
];

export function SimulatorGuideVisual() {
  const { display } = useLocale();
  const visualGuides = useVisualGuides();
  const guide = visualGuides.cutSimulator;

  return (
    <>
      <GuideStepList intro={guide.intro} steps={guide.steps} visuals={VISUALS} />
      {guide.sections?.map((section) => (
        <section className="info-page-section" key={section.heading}>
          <h2>{section.heading}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </section>
      ))}
      <p className="guide-related">
        {display.t("web.guides.related.simulatorBefore")}{" "}
        <LocalizedLink to="/handleiding/werkplan-printen">{display.t("web.guides.nav.werkplanExport")}</LocalizedLink>{" "}
        {display.t("web.guides.related.simulatorAfter")}{" "}
        <LocalizedLink to="/">{display.t("web.guides.related.planner")}</LocalizedLink>.
      </p>
    </>
  );
}
